export default "__VITE_ASSET__ChUZBF0R__"